import styles from './OrderInfoMofal.module.css'
import close from '../../assets/icons/close.svg'
import arrow from '../../assets/icons/IconArrowDownBlue.svg'
import CustomButton from '../UI/CustomButton/CustomButton'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useEffect, useState } from 'react'
import { ClaimResponseType } from '../../redux/actions/types'
import { useNavigate } from 'react-router-dom'
import robotoRegularBase64 from '../../assets/fonts/Roboto-Regular-base64'
import * as XLSX from 'xlsx-js-style'

import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'
import { addImageWithAspectRatio } from '../../utils/addImageWithAspectRatio'
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  WidthType,
  AlignmentType,
} from 'docx'
import { saveAs } from 'file-saver'

interface Props {
  onClose: () => any
  claimInfo: ClaimResponseType
}

const getMeasurementName = (measurement: string): string => {
  const measurementMap: { [key: string]: string } = {
    миллилитров: 'мл',
    миллилитр: 'мл',
    литров: 'л',
    литр: 'л',
    граммов: 'г',
    грамм: 'г',
    килограммов: 'кг',
    килограмм: 'кг',
    штук: 'шт',
    штука: 'шт',
    порций: 'порц',
    порция: 'порц',
    упаковка: 'уп',
    упаковки: 'уп',
  }

  return measurementMap[measurement.toLowerCase()] || measurement
}

const OrderInfoModal: React.FC<Props> = ({ onClose, claimInfo }) => {
  const dispatch = useAppDispatch()
  const [filteredDishes, setFilteredDishes] = useState<any[]>([])
  const [openMore, setOpenMore] = useState<boolean>(false)
  const { token } = useAppSelector((state) => state.auth)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const navigate = useNavigate()

  const [discountTotal, setDiscountTotal] = useState(0)
  const [serviceFeeTotal, setserviceFeeTotal] = useState(0)
  const [corkFeeTotal, setCorkFeeTotal] = useState(0)
  const { currentClaim } = useAppSelector((state) => state.claims)

  useEffect(() => {
    if (currentClaim?.order?.orderDetails) {
      const newFilteredDishes = currentClaim.order.orderDetails.map((detail) => ({
        id: detail.productId,
        name: detail.name,
        price: detail.price,
        quantity: detail.quantity,
        images: detail.images,
      }))

      if (JSON.stringify(newFilteredDishes) !== JSON.stringify(filteredDishes)) {
        setFilteredDishes(newFilteredDishes)
      }
    }
  }, [currentClaim, filteredDishes])

  const handleCreateOrderRedirect = () => {
    navigate(`/collectOrders-page?id=${currentClaim?.id}`)
  }

  const discount = currentClaim?.discountAmount || currentClaim?.discountPercent
  const serviceFee = currentClaim?.serviceFeeAmount || currentClaim?.serviceFeePercent
  const corkFee = currentClaim?.corkFeeAmount || currentClaim?.corkFeePercent
  const orderList = currentClaim?.order?.orderDetails
  useEffect(() => {
    if (discount == currentClaim?.discountAmount) {
      setDiscountTotal(currentClaim?.order?.price - (currentClaim?.order?.price - Number(discount)))
    }
    if (discount == currentClaim?.discountPercent) {
      setDiscountTotal(
        -(
          currentClaim?.order?.price -
          currentClaim?.order?.price -
          (currentClaim?.order?.price * Number(discount)) / 100
        ),
      )
    }

    const foodProductsTotal =
      orderList?.reduce((sum, item) => {
        const categoryType = item.category && 'type' in item.category ? item.category.type : null
        if (categoryType === 'food') {
          return sum + item.price * item.quantity
        }
        return sum
      }, 0) || 0

    const alcoholProductsTotal =
      orderList?.reduce((sum, item) => {
        const categoryType = item.category && 'type' in item.category ? item.category.type : null
        if (categoryType === 'alcohol') {
          return sum + item.price * item.quantity
        }
        return sum
      }, 0) || 0

    if (serviceFee == currentClaim?.serviceFeeAmount) {
      setserviceFeeTotal(Number(serviceFee))
    }
    if (serviceFee == currentClaim?.serviceFeePercent) {
      setserviceFeeTotal(Math.round((foodProductsTotal * Number(serviceFee)) / 100))
    }

    if (corkFee == currentClaim?.corkFeeAmount) {
      setCorkFeeTotal(Number(corkFee))
    }
    if (corkFee == currentClaim?.corkFeePercent) {
      setCorkFeeTotal(Math.round((alcoholProductsTotal * Number(corkFee)) / 100))
    }
  }, [dispatch, location, currentClaim])

  const smet = [discountTotal, serviceFeeTotal, corkFeeTotal, currentClaim?.order?.totalPrice]
  const smetExcel = [discountTotal, serviceFeeTotal, corkFeeTotal, currentClaim?.order?.totalPrice]

  const createPDFWithoutLogo = (doc: jsPDF) => {
    doc.addFileToVFS('Roboto-Regular.ttf', robotoRegularBase64)
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
    doc.setFont('Roboto', 'normal')
    doc.setFontSize(18)
    doc.text('Смета заказа', 14, 20)

    doc.setFontSize(12)
    doc.text(`Дата создания: ${new Date(claimInfo.createdAt).toLocaleDateString()}`, 14, 30)
    doc.text(
      `Дата проведения: ${new Date(claimInfo.startDate).toLocaleDateString()} - ${new Date(
        claimInfo.endDate,
      ).toLocaleDateString()}`,
      14,
      40,
    )
    doc.text(`Количество гостей: ${claimInfo.peopleCount}`, 14, 50)
    doc.text(`Название зала: ${claimInfo.place.name}`, 14, 60)
    doc.text(`Клиент: ${claimInfo.client?.fullName} (${claimInfo.client?.phone})`, 14, 70)
    doc.text(`Менеджер: ${currentClaim?.user?.fullName || 'Не указано'}`, 14, 80)
    doc.text(
      `Расстановка: ${claimInfo.arrangement || 'Не указано'} (Кол-во гостей: ${
        claimInfo.peopleCount
      })`,
      14,
      90,
    )

    const services = ((claimInfo as unknown as any)?.services || [])
      .map((s: any) => ({
        name: (s?.name || '').trim(),
        comment: (s?.comment || '').trim(),
      }))
      .filter((s: any) => s.name.length > 0 || s.comment.length > 0)

    const events = ((claimInfo as unknown as any)?.events || [])
      .map((e: any) => ({
        name: String(e?.name || '').trim(),
        comment: String(e?.comment || '').trim(),
        time: String(e?.time || '').trim(),
      }))
      .filter((e: any) => e.name.length > 0 || e.comment.length > 0 || e.time.length > 0)

    let startYForTable = 100
    if (services.length > 0) {
      doc.setFontSize(12)
      doc.text('Службы отеля', 14, 100)
      autoTable(doc, {
        head: [['Название службы', 'Комментарий']],
        body: services.map((s: any) => [s.name || '-', s.comment || '-']),
        startY: 105,
        theme: 'grid',
        styles: { font: 'Roboto', fontSize: 12 },
        headStyles: {
          font: 'Roboto',
          fillColor: [209, 209, 209],
          textColor: 0,
          fontSize: 12,
          fontStyle: 'normal',
        },
        willDrawCell: (data) => {
          if (data.section === 'head') {
            doc.setFont('Roboto', 'normal')
          }
        },
      })
      // @ts-ignore
      startYForTable = (doc as any).lastAutoTable?.finalY
        ? (doc as any).lastAutoTable.finalY + 10
        : 110
    }

    if (events.length > 0) {
      doc.setFontSize(12)
      doc.text('Мероприятия', 14, startYForTable)
      autoTable(doc, {
        head: [['Название', 'Время', 'Комментарий']],
        body: events.map((e: any) => [
          String(e.name || '-'),
          String(e.time || '-'),
          String(e.comment || '-'),
        ]),
        startY: startYForTable + 5,
        theme: 'grid',
        styles: { font: 'Roboto', fontSize: 12 },
        headStyles: {
          font: 'Roboto',
          fillColor: [209, 209, 209],
          textColor: 0,
          fontSize: 12,
          fontStyle: 'normal',
        },
        willDrawCell: (data) => {
          if (data.section === 'head') {
            doc.setFont('Roboto', 'normal')
          }
        },
      })
      // @ts-ignore
      startYForTable = (doc as any).lastAutoTable?.finalY
        ? (doc as any).lastAutoTable.finalY + 10
        : startYForTable + 20
    }

    doc.setFontSize(18)
    doc.text('Состав заказа', 13, startYForTable)

    const groupedByCategory = orderList.reduce((acc, item) => {
      const categoryType = (
        item.category && 'type' in item.category ? item.category.type : 'other'
      ) as string
      const menuName = item.menuName || 'Без меню'

      if (!acc[categoryType]) {
        acc[categoryType] = {}
      }
      if (!acc[categoryType][menuName]) {
        acc[categoryType][menuName] = []
      }
      acc[categoryType][menuName].push(item)
      return acc
    }, {} as Record<string, Record<string, typeof orderList>>)

    const categoryNames: Record<string, string> = {
      rent: 'Аренда оборудования',
      food: 'Еда и напитки',
      alcohol: 'Алкоголь',
      other: 'Прочее',
    }

    let currentY = startYForTable + 10

    Object.entries(groupedByCategory).forEach(([categoryType, menus]) => {
      const categoryName = categoryNames[categoryType] || 'Прочее'

      doc.setFontSize(16)
      doc.setFont('Roboto', 'normal')
      doc.text(categoryName, 14, currentY)
      currentY += 8

      Object.entries(menus).forEach(([menuName, items]) => {
        if (items.length > 0) {
          doc.setFontSize(11)

          doc.setFont('Roboto', 'normal')
          doc.text(`  ${String(menuName)}`, 15, currentY)

          const itemsData = items.map((item) => [
            item.name,
            item.price.toString() + ' руб.',
            getMeasurementName(item.measurement || 'шт'),
            (item.weight || 0).toString(),
            item.quantity.toString() + ' шт.',
            (item.price * item.quantity).toString() + ' руб.',
            item.comment || '',
          ])
          autoTable(doc, {
            head: [['Имя', 'Цена', 'Ед. изм.', 'Выход', 'Кол-во', 'Итого', 'Комментарий']],
            body: itemsData,
            startY: currentY + 5,
            theme: 'grid',
            styles: {
              font: 'Roboto',
              fontSize: 12,
              cellPadding: 4,
              lineColor: [0, 0, 0],
              lineWidth: 0.1,
              halign: 'left',
              valign: 'middle',
            },
            headStyles: {
              font: 'Roboto',
              fillColor: [209, 209, 209],
              textColor: 0,
              fontSize: 12,
              fontStyle: 'normal',
              cellPadding: 4,
              halign: 'center',
              valign: 'middle',
            },
            columnStyles: {
              0: { halign: 'left', cellWidth: 48 },
              1: { halign: 'right', cellWidth: 19 },
              2: { halign: 'center', cellWidth: 17 },
              3: { halign: 'center', cellWidth: 17 },
              4: { halign: 'center', cellWidth: 21 },
              5: { halign: 'right', cellWidth: 21 },
              6: { halign: 'left', cellWidth: 38 },
            },
            willDrawCell: (data) => {
              if (data.section === 'head') {
                doc.setFont('Roboto', 'normal')
              }
            },
          })
          // @ts-ignore
          currentY = (doc as any).lastAutoTable?.finalY
            ? (doc as any).lastAutoTable.finalY + 10
            : currentY + 20
        }
      })
    })

    // @ts-ignore
    let finalY = currentY

    if (finalY + 50 > 280) {
      doc.addPage()
      finalY = 20
    }

    doc.setFontSize(12)
    doc.text('Скидка: ' + smet[0] + ' руб.', 14, finalY + 10)
    doc.text('Сервисный сбор: ' + smet[1] + ' руб.', 14, finalY + 20)
    doc.text('Пробковый сбор: ' + smet[2] + ' руб.', 14, finalY + 30)
    doc.setFontSize(14)
    doc.text('Итоговая сумма: ' + smet[3] + ' руб.', 14, finalY + 40)

    doc.save('Смета_заказа.pdf')
  }

  const handleDownloadPDF = async () => {
    const hasLogo = claimInfo.place.establishment?.logo

    if (!hasLogo) {
      const doc = new jsPDF()
      createPDFWithoutLogo(doc)
      return
    }

    downloadPDFWithLogo()
  }

  const downloadPDFWithLogo = async () => {
    const doc = new jsPDF()

    doc.addFileToVFS('Roboto-Regular.ttf', robotoRegularBase64)
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
    doc.setFont('Roboto', 'normal')

    try {
      const logoUrl = `${process.env.REACT_APP_BASE_URL_IMAGES}${claimInfo.place.establishment?.logo}`
      const response = await fetch(logoUrl)

      if (!response.ok) {
        throw new Error('Не удалось загрузить логотип')
      }

      const blob = await response.blob()
      const reader = new FileReader()

      reader.onload = async function () {
        const imgData = reader.result as string

        await addImageWithAspectRatio(doc, imgData, 150, 10, 40, 40, 'JPEG')

        doc.setFontSize(18)
        doc.text('Смета заказа', 14, 20)

        doc.setFontSize(12)
        doc.text(
          `Дата создания заявки: ${new Date(claimInfo.createdAt).toLocaleDateString()}`,
          14,
          30,
        )
        doc.text(
          `Дата проведения: ${new Date(claimInfo.startDate).toLocaleDateString()} - ${new Date(
            claimInfo.endDate,
          ).toLocaleDateString()}`,
          14,
          40,
        )
        doc.text(`Количество гостей: ${claimInfo.peopleCount}`, 14, 50)
        doc.text(`Название зала: ${claimInfo.place.name}`, 14, 60)
        doc.text(`Клиент: ${claimInfo.client?.fullName} (${claimInfo.client?.phone})`, 14, 70)
        doc.text(`Менеджер: ${currentClaim?.user?.fullName || 'Не указано'}`, 14, 80)
        doc.text(
          `Расстановка: ${claimInfo.arrangement || 'Не указано'} (Кол-во гостей: ${
            claimInfo.peopleCount
          })`,
          14,
          90,
        )

        const services = ((claimInfo as unknown as any)?.services || [])
          .map((s: any) => ({
            name: (s?.name || '').trim(),
            comment: (s?.comment || '').trim(),
          }))
          .filter((s: any) => s.name.length > 0 || s.comment.length > 0)

        const events = ((claimInfo as unknown as any)?.events || [])
          .map((e: any) => ({
            name: String(e?.name || '').trim(),
            comment: String(e?.comment || '').trim(),
            time: String(e?.time || '').trim(),
          }))
          .filter((e: any) => e.name.length > 0 || e.comment.length > 0 || e.time.length > 0)

        let startYForTable = 100
        if (services.length > 0) {
          doc.setFontSize(12)
          doc.text('Службы отеля', 14, 100)
          autoTable(doc, {
            head: [['Название службы', 'Комментарий']],
            body: services.map((s: any) => [s.name || '-', s.comment || '-']),
            startY: 105,
            theme: 'grid',
            styles: { font: 'Roboto', fontSize: 12 },
            headStyles: {
              font: 'Roboto',
              fillColor: [209, 209, 209],
              textColor: 0,
              fontSize: 12,
              fontStyle: 'normal',
            },
            willDrawCell: (data) => {
              if (data.section === 'head') {
                doc.setFont('Roboto', 'normal')
              }
            },
          })
          // @ts-ignore
          startYForTable = (doc as any).lastAutoTable?.finalY
            ? (doc as any).lastAutoTable.finalY + 10
            : 110
        }

        if (events.length > 0) {
          doc.setFontSize(12)
          doc.text('Мероприятия', 14, startYForTable)
          autoTable(doc, {
            head: [['Название', 'Время', 'Комментарий']],
            body: events.map((e: any) => [
              String(e.name || '-'),
              String(e.time || '-'),
              String(e.comment || '-'),
            ]),
            startY: startYForTable + 5,
            theme: 'grid',
            styles: { font: 'Roboto', fontSize: 12 },
            headStyles: {
              font: 'Roboto',
              fillColor: [209, 209, 209],
              textColor: 0,
              fontSize: 12,
              fontStyle: 'normal',
            },
            willDrawCell: (data) => {
              if (data.section === 'head') {
                doc.setFont('Roboto', 'normal')
              }
            },
          })
          // @ts-ignore
          startYForTable = (doc as any).lastAutoTable?.finalY
            ? (doc as any).lastAutoTable.finalY + 10
            : startYForTable + 20
        }

        doc.setFontSize(18)
        doc.text('Состав заказа', 13, startYForTable)

        const groupedByCategory = orderList.reduce((acc, item) => {
          const categoryType = (
            item.category && 'type' in item.category ? item.category.type : 'other'
          ) as string
          const menuName = item.menuName || 'Без меню'

          if (!acc[categoryType]) {
            acc[categoryType] = {}
          }
          if (!acc[categoryType][menuName]) {
            acc[categoryType][menuName] = []
          }
          if (acc[categoryType] && acc[categoryType][menuName]) {
            acc[categoryType][menuName].push(item)
          }
          return acc
        }, {} as Record<string, Record<string, typeof orderList>>)

        const categoryNames: Record<string, string> = {
          rent: 'Аренда оборудования',
          food: 'Еда и напитки',
          alcohol: 'Алкоголь',
          other: 'Прочее',
        }

        let currentY = startYForTable + 10

        Object.entries(groupedByCategory).forEach(([categoryType, menus]) => {
          const categoryName = categoryNames[categoryType] || 'Прочее'
          doc.setFontSize(16)
          doc.text(categoryName, 14, currentY)
          currentY += 8

          Object.entries(menus).forEach(([menuName, items]) => {
            if (items.length > 0) {
              doc.setFontSize(11)
              doc.setFont('Roboto', 'normal')
              doc.text(`  ${String(menuName)}`, 14, currentY)

              const itemsData = items.map((item) => [
                item.name,
                item.price.toString() + ' руб.',
                getMeasurementName(item.measurement || 'шт'),
                (item.weight || 0).toString(),
                item.quantity.toString() + ' шт.',
                (item.price * item.quantity).toString() + ' руб.',
                item.comment || '',
              ])
              autoTable(doc, {
                head: [['Имя', 'Цена', 'Ед. изм.', 'Выход', 'Кол-во', 'Итого', 'Комментарий']],
                body: itemsData,
                startY: currentY + 5,
                theme: 'grid',
                styles: {
                  font: 'Roboto',
                  fontSize: 12,
                  cellPadding: 4,
                  lineColor: [0, 0, 0],
                  lineWidth: 0.1,
                  halign: 'left',
                  valign: 'middle',
                },
                headStyles: {
                  font: 'Roboto',
                  fillColor: [209, 209, 209],
                  textColor: 0,
                  fontSize: 12,
                  fontStyle: 'normal',
                  cellPadding: 4,
                  halign: 'center',
                  valign: 'middle',
                },
                columnStyles: {
                  0: { halign: 'left', cellWidth: 48 },
                  1: { halign: 'right', cellWidth: 19 },
                  2: { halign: 'center', cellWidth: 17 },
                  3: { halign: 'center', cellWidth: 17 },
                  4: { halign: 'center', cellWidth: 21 },
                  5: { halign: 'right', cellWidth: 21 },
                  6: { halign: 'left', cellWidth: 38 },
                },
                willDrawCell: (data) => {
                  if (data.section === 'head') {
                    doc.setFont('Roboto', 'normal')
                  }
                },
              })
              // @ts-ignore
              currentY = (doc as any).lastAutoTable?.finalY
                ? (doc as any).lastAutoTable.finalY + 10
                : currentY + 20
            }
          })
        })

        // @ts-ignore
        let finalY = currentY

        if (finalY + 50 > 280) {
          doc.addPage()
          finalY = 20
        }

        doc.setFontSize(12)
        doc.text('Скидка: ' + smet[0] + ' руб.', 14, finalY + 10)
        doc.text('Сервисный сбор: ' + smet[1] + ' руб.', 14, finalY + 20)
        doc.text('Пробковый сбор: ' + smet[2] + ' руб.', 14, finalY + 30)
        doc.setFontSize(14)
        doc.text('Итоговая сумма: ' + smet[3] + ' руб.', 14, finalY + 40)

        doc.save('Смета_заказа.pdf')
      }

      reader.readAsDataURL(blob)
    } catch (error) {
      console.error('Ошибка загрузки логотипа:', error)

      createPDFWithoutLogo(doc)
    }
  }

  const downloadExcel = () => {
    const services = ((claimInfo as unknown as any)?.services || [])
      .map((s: any) => ({
        name: (s?.name || '').trim(),
        comment: (s?.comment || '').trim(),
      }))
      .filter((s: any) => s.name.length > 0 || s.comment.length > 0)

    const events = ((claimInfo as unknown as any)?.events || [])
      .map((e: any) => ({
        name: String(e?.name || '').trim(),
        comment: String(e?.comment || '').trim(),
        time: String(e?.time || '').trim(),
      }))
      .filter((e: any) => e.name.length > 0 || e.comment.length > 0 || e.time.length > 0)

    const metadata = [
      {
        Имя: 'Дата создания заявки',
        Цена: new Date(claimInfo.createdAt).toLocaleDateString(),
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      {
        Имя: 'Дата проведения',
        Цена: `${new Date(claimInfo.startDate).toLocaleDateString()} - ${new Date(
          claimInfo.endDate,
        ).toLocaleDateString()}`,
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      {
        Имя: 'Количество гостей',
        Цена: claimInfo.peopleCount,
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      {
        Имя: 'Название зала',
        Цена: claimInfo.place.name,
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      {
        Имя: 'Клиент',
        Цена: `${claimInfo.client?.fullName} (${claimInfo.client?.phone})`,
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      {
        Имя: 'Менеджер',
        Цена: currentClaim?.user?.fullName || 'Не указано',
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      {
        Имя: 'Расстановка',
        Цена: `${claimInfo.arrangement || 'Не указано'} (Кол-во гостей: ${claimInfo.peopleCount})`,
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Комментарий: '',
      },
      { Имя: '', Цена: '', 'Ед. изм.': '', Выход: '', Количество: '', Комментарий: '' },
      ...(services.length > 0
        ? ([
            {
              Имя: 'Службы отеля',
              Цена: '',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Комментарий: '',
            },
            {
              Имя: 'Название службы',
              Цена: 'Комментарий',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Комментарий: '',
            },
            ...services.map((s: any, index: number) => ({
              Имя: s.name || `Служба ${index + 1}`,
              Цена: s.comment || '',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Комментарий: '',
            })),
            { Имя: '', Цена: '', 'Ед. изм.': '', Выход: '', Количество: '', Комментарий: '' },
          ] as any[])
        : []),
      ...(events.length > 0
        ? ([
            {
              Имя: 'Мероприятия',
              Цена: '',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Итого: '',
              Комментарий: '',
            },
            {
              Имя: 'Название мероприятия',
              Цена: 'Время',
              'Ед. изм.': 'Комментарий',
              Выход: '',
              Количество: '',
              Итого: '',
              Комментарий: '',
            },
            ...events.map((e: any, index: number) => ({
              Имя: e.name || `Мероприятие ${index + 1}`,
              Цена: e.time || '' || '',
              'Ед. изм.': e.comment || '',
              Выход: '',
              Количество: '',
              Комментарий: '',
              Итого: '',
            })),
            {
              Имя: '',
              Цена: '',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Итого: '',
              Комментарий: '',
            },
          ] as any[])
        : []),
      {
        Имя: 'Состав заказа',
        Цена: 'Цена',
        'Ед. изм.': 'Ед. изм.',
        Выход: 'Выход',
        Количество: 'Количество',
        Итого: 'Итого',
        Комментарий: 'Комментарий',
      },
    ]

    const groupedByCategory = orderList.reduce((acc, item) => {
      const categoryType = (
        item.category && 'type' in item.category ? item.category.type : 'other'
      ) as string
      const menuName = item.menuName || 'Без меню'

      if (!acc[categoryType]) {
        acc[categoryType] = {}
      }
      if (!acc[categoryType][menuName]) {
        acc[categoryType][menuName] = []
      }
      if (acc[categoryType] && acc[categoryType][menuName]) {
        acc[categoryType][menuName].push(item)
      }
      return acc
    }, {} as Record<string, Record<string, typeof orderList>>)

    const categoryNames: Record<string, string> = {
      rent: 'Аренда оборудования',
      food: 'Еда и напитки',
      alcohol: 'Алкоголь',
      other: 'Прочее',
    }

    const orderData = [
      ...Object.entries(groupedByCategory).flatMap(([categoryType, menus]) => {
        const categoryName = categoryNames[categoryType] || 'Прочее'
        return [
          {
            Имя: categoryName,
            Цена: '',
            'Ед. изм.': '',
            Выход: '',
            Количество: '',
            Итого: '',
            Комментарий: '',
          },
          ...Object.entries(menus).flatMap(([menuName, items]) => [
            {
              Имя: `  ${menuName}`,
              Цена: '',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Итого: '',
              Комментарий: '',
            },
            ...items.map((item) => ({
              Имя: item.name,
              Цена: item.price + ' руб.',
              'Ед. изм.': getMeasurementName(item.measurement || 'шт'),
              Выход: item.weight || 0,
              Количество: item.quantity,
              Итого: item.price * item.quantity + ' руб.',
              Комментарий: item.comment || '',
            })),
            {
              Имя: '',
              Цена: '',
              'Ед. изм.': '',
              Выход: '',
              Количество: '',
              Итого: '',
              Комментарий: '',
            },
          ]),
          {
            Имя: '',
            Цена: '',
            'Ед. изм.': '',
            Выход: '',
            Количество: '',
            Итого: '',
            Комментарий: '',
          },
        ]
      }),
      {
        Имя: 'Скидка:',
        Цена: smetExcel[0] + ' руб',
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Итого: '',
        Комментарий: '',
      },
      {
        Имя: 'Сервисный сбор:',
        Цена: smetExcel[1] + ' руб',
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Итого: '',
        Комментарий: '',
      },
      {
        Имя: 'Пробковый сбор:',
        Цена: smetExcel[2] + ' руб',
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Итого: '',
        Комментарий: '',
      },
      {
        Имя: 'Итоговая сумма:',
        Цена: smetExcel[3] + ' руб',
        'Ед. изм.': '',
        Выход: '',
        Количество: '',
        Итого: '',
        Комментарий: '',
      },
    ]

    const dataForExcel = [...metadata, ...orderData]

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel, { skipHeader: true })
    worksheet['!cols'] = [
      { wch: 35 },
      { wch: 15 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 40 },
    ]

    const serviceHeaderRow = services.length > 0 ? 8 : -1
    const serviceColsHeaderRow = services.length > 0 ? 9 : -1

    let eventsHeaderRow = -1
    let eventsColsHeaderRow = -1
    if (events.length > 0) {
      if (services.length > 0) {
        eventsHeaderRow = 8 + 2 + services.length + 1
        eventsColsHeaderRow = eventsHeaderRow + 1
      } else {
        eventsHeaderRow = 8
        eventsColsHeaderRow = 9
      }
    }

    let currentRowIndex = metadata.length

    Object.values(groupedByCategory).forEach((menus) => {
      currentRowIndex += 1
      Object.values(menus).forEach((items) => {
        if (items.length > 0) {
          currentRowIndex += items.length + 2
        }
      })
      currentRowIndex += 1
    })

    const borderStyle = {
      top: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    }

    const thickBorderStyle = {
      top: { style: 'medium', color: { rgb: '000000' } },
      left: { style: 'medium', color: { rgb: '000000' } },
      bottom: { style: 'medium', color: { rgb: '000000' } },
      right: { style: 'medium', color: { rgb: '000000' } },
    }

    const range = XLSX.utils.decode_range(worksheet['!ref'] || '')
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C })
        if (!worksheet[cellRef]) {
          worksheet[cellRef] = { t: 's', v: '' }
        }

        let cellStyle: any = {
          border: borderStyle,
          alignment: { vertical: 'center', wrapText: true },
        }

        if (R >= 0 && R <= 6) {
          if (C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 11, color: { rgb: '000000' } },
              fill: { fgColor: { rgb: 'E0E0E0' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          } else if (C === 1) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          }
        }

        if (R === serviceHeaderRow && C === 0) {
          cellStyle = {
            ...cellStyle,
            font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
            fill: { fgColor: { rgb: '5A5A5A' } },
            alignment: { vertical: 'center', horizontal: 'center' },
          }
        }

        if (R === serviceColsHeaderRow && (C === 0 || C === 1)) {
          cellStyle = {
            ...cellStyle,
            font: { bold: true, sz: 11, color: { rgb: '000000' } },
            fill: { fgColor: { rgb: 'D0D0D0' } },
            alignment: { vertical: 'center', horizontal: 'center' },
          }
        }

        if (
          services.length > 0 &&
          R > serviceColsHeaderRow &&
          R < serviceHeaderRow + 2 + services.length
        ) {
          if (C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              fill: { fgColor: { rgb: 'F5F5F5' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          } else if (C === 1) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              fill: { fgColor: { rgb: 'F5F5F5' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          }
        }

        if (R === eventsHeaderRow && C === 0) {
          cellStyle = {
            ...cellStyle,
            font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
            fill: { fgColor: { rgb: '6A6A6A' } },
            alignment: { vertical: 'center', horizontal: 'center' },
          }
        }

        if (R === eventsColsHeaderRow && (C === 0 || C === 1 || C === 2)) {
          cellStyle = {
            ...cellStyle,
            font: { bold: true, sz: 11, color: { rgb: '000000' } },
            fill: { fgColor: { rgb: 'D8D8D8' } },
            alignment: { vertical: 'center', horizontal: 'center' },
          }
        }

        if (
          events.length > 0 &&
          R > eventsColsHeaderRow &&
          R < eventsHeaderRow + 2 + events.length
        ) {
          if (C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              fill: { fgColor: { rgb: 'F8F8F8' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          } else if (C === 1) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              fill: { fgColor: { rgb: 'F8F8F8' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          } else if (C === 2) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              fill: { fgColor: { rgb: 'F8F8F8' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          }
        }

        if (R >= metadata.length && R < currentRowIndex) {
          const isCategoryHeader = Object.values(groupedByCategory).some((menus, categoryIndex) => {
            let rowOffset = metadata.length
            for (let i = 0; i < categoryIndex; i++) {
              const categoryMenus = Object.values(groupedByCategory)[i]
              rowOffset += 1
              Object.values(categoryMenus).forEach((items) => {
                if (items.length > 0) {
                  rowOffset += items.length + 2
                }
              })
              rowOffset += 1
            }
            return R === rowOffset
          })

          const isMenuHeader = Object.values(groupedByCategory).some((menus, categoryIndex) => {
            let rowOffset = metadata.length
            for (let i = 0; i < categoryIndex; i++) {
              const categoryMenus = Object.values(groupedByCategory)[i]
              rowOffset += 1
              Object.values(categoryMenus).forEach((items) => {
                if (items.length > 0) {
                  rowOffset += items.length + 2
                }
              })
              rowOffset += 1
            }
            rowOffset += 1

            return Object.values(menus).some((items, menuIndex) => {
              let menuRowOffset = rowOffset
              for (let j = 0; j < menuIndex; j++) {
                const menuItems = Object.values(menus)[j]
                if (menuItems.length > 0) {
                  menuRowOffset += menuItems.length + 2
                }
              }
              return R === menuRowOffset
            })
          })

          if (isCategoryHeader && C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 14, color: { rgb: 'FFFFFF' } },
              fill: { fgColor: { rgb: '2A2A2A' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          }

          if (isMenuHeader && C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
              fill: { fgColor: { rgb: '4A4A4A' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          }

          if (!isCategoryHeader && !isMenuHeader && C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { sz: 11 },
              alignment: { vertical: 'center', horizontal: 'left', wrapText: true },
            }
          }
        }

        if (R === metadata.length - 1) {
          if (C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
              fill: { fgColor: { rgb: '4A4A4A' } },
              alignment: { vertical: 'center', horizontal: 'center' },
            }
          } else if (C >= 1 && C <= 5) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 11, color: { rgb: 'FFFFFF' } },
              fill: { fgColor: { rgb: '7A7A7A' } },
              alignment: { vertical: 'center', horizontal: 'center' },
            }
          }
        }

        if (R >= currentRowIndex && R <= currentRowIndex + 3) {
          if (C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 11 },
              fill: { fgColor: { rgb: 'E8E8E8' } },
              alignment: { vertical: 'center', horizontal: 'left' },
            }
          }
          if (C === 1) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 11, color: { rgb: '000000' } },
              fill: { fgColor: { rgb: 'D3D3D3' } },
              alignment: { vertical: 'center', horizontal: 'right' },
            }
          }
        }

        if (R === currentRowIndex + 3) {
          if (C === 0) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
              fill: { fgColor: { rgb: '3A3A3A' } },
              alignment: { vertical: 'center', horizontal: 'left' },
              border: thickBorderStyle,
            }
          }
          if (C === 1) {
            cellStyle = {
              ...cellStyle,
              font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
              fill: { fgColor: { rgb: '5A5A5A' } },
              alignment: { vertical: 'center', horizontal: 'right' },
              border: thickBorderStyle,
            }
          }
        }

        if (C === 1 || C === 3 || C === 4) {
          if (!cellStyle.alignment) {
            cellStyle.alignment = {}
          }
          if (
            R > 6 &&
            R !== serviceHeaderRow &&
            R !== eventsHeaderRow &&
            R !== metadata.length - 1
          ) {
            cellStyle.alignment.horizontal = 'right'
          }
        }

        // @ts-ignore
        worksheet[cellRef].s = cellStyle
      }
    }

    worksheet['!rows'] = []
    for (let R = range.s.r; R <= range.e.r; ++R) {
      if (
        R === serviceHeaderRow ||
        R === eventsHeaderRow ||
        R === metadata.length - 1 ||
        R === currentRowIndex + 3
      ) {
        worksheet['!rows'][R] = { hpt: 25 }
      } else {
        worksheet['!rows'][R] = { hpt: 20 }
      }
    }

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Смета заказа')

    XLSX.writeFile(workbook, 'Сметаа_заказа.xlsx')
  }

  const downloadWord = async () => {
    const services = ((claimInfo as unknown as any)?.services || [])
      .map((s: any) => ({
        name: (s?.name || '').trim(),
        comment: (s?.comment || '').trim(),
      }))
      .filter((s: any) => s.name.length > 0 || s.comment.length > 0)

    const events = ((claimInfo as unknown as any)?.events || [])
      .map((e: any) => ({
        name: String(e?.name || '').trim(),
        comment: String(e?.comment || '').trim(),
        time: String(e?.time || '').trim(),
      }))
      .filter((e: any) => e.name.length > 0 || e.comment.length > 0 || e.time.length > 0)

    const groupedByCategory =
      orderList?.reduce((acc, item) => {
        const categoryType = (
          item.category && 'type' in item.category ? item.category.type : 'other'
        ) as string
        const menuName = item.menuName || 'Без меню'

        if (!acc[categoryType]) {
          acc[categoryType] = {}
        }
        if (!acc[categoryType][menuName]) {
          acc[categoryType][menuName] = []
        }
        if (acc[categoryType] && acc[categoryType][menuName]) {
          acc[categoryType][menuName].push(item)
        }
        return acc
      }, {} as Record<string, Record<string, typeof orderList>>) || {}

    const categoryNames: Record<string, string> = {
      rent: 'Аренда оборудования',
      food: 'Еда и напитки',
      alcohol: 'Алкоголь',
      other: 'Прочее',
    }

    const children: (Paragraph | Table)[] = []

    children.push(
      new Paragraph({
        text: 'Смета заказа',
        heading: 'Heading1',
        spacing: { after: 300 },
        alignment: AlignmentType.CENTER,
      }),
    )

    children.push(
      new Paragraph({
        text: `Дата создания: ${new Date(claimInfo.createdAt).toLocaleDateString()}`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Дата проведения: ${new Date(claimInfo.startDate).toLocaleDateString()} - ${new Date(
          claimInfo.endDate,
        ).toLocaleDateString()}`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Количество гостей: ${claimInfo.peopleCount}`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Название зала: ${claimInfo.place.name}`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Клиент: ${claimInfo.client?.fullName} (${claimInfo.client?.phone})`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Менеджер: ${currentClaim?.user?.fullName || 'Не указано'}`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Расстановка: ${claimInfo.arrangement || 'Не указано'} (Кол-во гостей: ${
          claimInfo.peopleCount
        })`,
        spacing: { after: 200 },
      }),
    )

    if (services.length > 0) {
      children.push(
        new Paragraph({
          text: 'Службы отеля',
          heading: 'Heading2',
          spacing: { before: 200, after: 100 },
        }),
      )

      const serviceTableRows = [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: 'Название службы',
                  run: { bold: true },
                }),
              ],
              width: { size: 50, type: WidthType.PERCENTAGE },
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: 'Комментарий',
                  run: { bold: true },
                }),
              ],
              width: { size: 50, type: WidthType.PERCENTAGE },
            }),
          ],
        }),
        ...services.map(
          (s: any) =>
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph(s.name || '-')],
                }),
                new TableCell({
                  children: [new Paragraph(s.comment || '-')],
                }),
              ],
            }),
        ),
      ]

      children.push(
        new Table({
          rows: serviceTableRows,
          width: { size: 100, type: WidthType.PERCENTAGE },
        }),
      )
    }

    if (events.length > 0) {
      children.push(
        new Paragraph({
          text: 'Мероприятия',
          heading: 'Heading2',
          spacing: { before: 200, after: 100 },
        }),
      )

      const eventsTableRows = [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: 'Название',
                  run: { bold: true },
                }),
              ],
              width: { size: 33, type: WidthType.PERCENTAGE },
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: 'Время',
                  run: { bold: true },
                }),
              ],
              width: { size: 33, type: WidthType.PERCENTAGE },
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: 'Комментарий',
                  run: { bold: true },
                }),
              ],
              width: { size: 34, type: WidthType.PERCENTAGE },
            }),
          ],
        }),
        ...events.map(
          (e: any) =>
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph(String(e.name || '-'))],
                }),
                new TableCell({
                  children: [new Paragraph(String(e.time || '-'))],
                }),
                new TableCell({
                  children: [new Paragraph(String(e.comment || '-'))],
                }),
              ],
            }),
        ),
      ]

      children.push(
        new Table({
          rows: eventsTableRows,
          width: { size: 100, type: WidthType.PERCENTAGE },
        }),
      )
    }

    children.push(
      new Paragraph({
        text: 'Состав заказа',
        heading: 'Heading1',
        spacing: { before: 300, after: 200 },
      }),
    )

    Object.entries(groupedByCategory).forEach(([categoryType, menus]) => {
      const categoryName = categoryNames[categoryType] || 'Прочее'

      children.push(
        new Paragraph({
          text: categoryName,
          heading: 'Heading2',
          spacing: { before: 200, after: 100 },
        }),
      )

      Object.entries(menus).forEach(([menuName, items]) => {
        if (items && items.length > 0) {
          children.push(
            new Paragraph({
              text: menuName,
              run: { bold: true, italics: true },
              spacing: { before: 100, after: 100 },
            }),
          )

          const orderTableRows = [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Имя',
                      run: { bold: true },
                    }),
                  ],
                  width: { size: 25, type: WidthType.PERCENTAGE },
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Цена',
                      run: { bold: true },
                      alignment: AlignmentType.RIGHT,
                    }),
                  ],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Ед. изм.',
                      run: { bold: true },
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Выход',
                      run: { bold: true },
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Кол-во',
                      run: { bold: true },
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Итого',
                      run: { bold: true },
                      alignment: AlignmentType.RIGHT,
                    }),
                  ],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      text: 'Комментарий',
                      run: { bold: true },
                    }),
                  ],
                  width: { size: 25, type: WidthType.PERCENTAGE },
                }),
              ],
            }),
            ...items.map(
              (item) =>
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph(item.name)],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: `${item.price} руб.`,
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: getMeasurementName(item.measurement || 'шт'),
                          alignment: AlignmentType.CENTER,
                        }),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: (item.weight || 0).toString(),
                          alignment: AlignmentType.CENTER,
                        }),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: `${item.quantity} шт.`,
                          alignment: AlignmentType.CENTER,
                        }),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: `${item.price * item.quantity} руб.`,
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                    }),
                    new TableCell({
                      children: [new Paragraph(item.comment || '')],
                    }),
                  ],
                }),
            ),
          ]

          children.push(
            new Table({
              rows: orderTableRows,
              width: { size: 100, type: WidthType.PERCENTAGE },
            }),
          )
        }
      })
    })

    children.push(
      new Paragraph({
        text: `Скидка: ${smet[0]} руб.`,
        spacing: { before: 300, after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Сервисный сбор: ${smet[1]} руб.`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Пробковый сбор: ${smet[2]} руб.`,
        spacing: { after: 100 },
      }),
    )
    children.push(
      new Paragraph({
        text: `Итоговая сумма: ${smet[3]} руб.`,
        run: { bold: true },
        spacing: { before: 100, after: 100 },
        heading: 'Heading2',
      }),
    )

    const doc = new Document({
      sections: [
        {
          children,
        },
      ],
    })

    Packer.toBlob(doc).then((blob: Blob) => {
      saveAs(blob, 'Смета_заказа.docx')
    })
  }

  return (
    <div className={styles.modalContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Состав заказа №{currentClaim?.order?.id} </h1>
          <img onClick={onClose} className={styles.close} src={close} alt='close' />
        </div>
        {filteredDishes.length >= 1 && (
          <div className={styles.content}>
            {filteredDishes.map((order) => {
              const orderDetail = currentClaim?.order?.orderDetails.find(
                (item) => item.productId === order.id,
              )
              return (
                <div key={order.id} className={styles.orderItem}>
                  <div className={styles.orderItemContainer}>
                    <div className={styles.imgContainer}>
                      <img src={`${process.env.REACT_APP_BASE_URL_IMAGES}/${order.images[0]}`} />
                      <span className={styles.name}>{order.name}</span>{' '}
                    </div>

                    <span className={styles.price}>
                      {orderDetail?.quantity}x{order.price} руб
                    </span>
                  </div>
                  {orderDetail?.comment && (
                    <div className={styles.comment}>{orderDetail.comment}</div>
                  )}
                </div>
              )
            })}
          </div>
        )}
        {currentClaim?.order && currentClaim?.order?.orderDetails && (
          <div className={styles.orderInfoContainer}>
            <div className={styles.totalPriceContainer}>
              <span className={styles.totalPriceTitle}>Итоговая сумма заказа</span>
              <span className={styles.totalPrice}>{currentClaim?.order?.totalPrice} руб</span>
            </div>
            <div className={styles.moreContainer}>
              <div onClick={() => setOpenMore(!openMore)} className={styles.moreWrapper}>
                <img src={arrow} />
                <span className={styles.moreTitle}>{openMore ? 'Свернуть' : 'Подробнее'}</span>
              </div>
              {openMore && (
                <>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>
                      Скидка {discount == currentClaim?.discountPercent ? discount : ''}
                      {discount == currentClaim?.discountPercent ? '%' : ''}
                    </span>
                    <span className={styles.rightSide}>{discountTotal} руб.</span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>
                      Сервисный сбор{' '}
                      {serviceFee == currentClaim?.serviceFeePercent ? serviceFee : ''}
                      {serviceFee == currentClaim?.serviceFeePercent ? '%' : ''}
                    </span>
                    <span className={styles.rightSide}>{serviceFeeTotal} руб</span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>Стоимость аренды площадки</span>
                    <span className={styles.rightSide}>
                      {currentClaim?.place?.establishment?.rentCost} руб
                    </span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>
                      Пробковый сбор {corkFee == currentClaim?.corkFeePercent ? corkFee : ''}
                      {corkFee == currentClaim?.corkFeePercent ? '%' : ''}
                    </span>
                    <span className={styles.rightSide}>{corkFeeTotal} руб</span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>Сумма заказа без учета скидок и сборов</span>
                    <span className={styles.rightSide}>{currentClaim?.order?.price} руб</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <div className={styles.footerContainer}>
        <Select
          className={styles.reactSelect}
          classNamePrefix='react-select'
          value={null}
          options={[
            {
              value: 'download-pdf',
              label: 'Загрузить PDF',
              action: handleDownloadPDF,
            },
            {
              value: 'download-excel',
              label: 'Загрузить Excel',
              action: downloadExcel,
            },
            {
              value: 'download-word',
              label: 'Загрузить Word',
              action: downloadWord,
            },
          ]}
          menuPlacement={isMobile ? 'top' : 'bottom'}
          onChange={(selectedOption) => {
            if (selectedOption && selectedOption.action) {
              selectedOption.action()
            }
          }}
          name='export-actions'
          isClearable={false}
          placeholder='Загрузить смету'
          noOptionsMessage={() => 'Нет вариантов экспорта'}
          styles={{
            control: (provided) => ({
              ...provided,
              border: 'none',
              boxShadow: 'none',
              minHeight: 28,

              backgroundColor: 'transparent',
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 5,
              right: 0,
            }),
            input: (provided) => ({
              ...provided,
              margin: 0,
              padding: 0,
              fontSize: isMobile ? 13 : 11,
              height: isMobile ? 42 : 24,
            }),
            placeholder: (provided) => ({ ...provided, color: 'black' }),
            valueContainer: (provided) => ({
              ...provided,
              padding: 0,
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            clearIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
          }}
        />
        <CustomButton onClick={handleCreateOrderRedirect} title='Изменить заказ' />
      </div>
    </div>
  )
}

export default OrderInfoModal
